<button [disabled]="disabled" class="save-icon" mat-icon-button>
  <mat-icon svgIcon="{{EsvgFiles.save}}"></mat-icon>
</button>
